import { Fancybox } from "@fancyapps/ui";

Fancybox.bind(".gallery a", {
    groupAll: false, // Group all items
    on: {
        ready: (fancybox) => {
            console.log(`fancybox #${fancybox.id} is ready!`);
        }
    }
});
